var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.107 7.333h2.226a1.333 1.333 0 011.333 1.333v2.227l.667.667 4-2.894v6.667m-4.666-.667v.667a1.333 1.333 0 01-1.334 1.333H6a1.333 1.333 0 01-1.333-1.333V8.666A1.333 1.333 0 016 7.333h1.333l7.333 7.333z",
    stroke: "#231A1A",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 4.667l14.666 14.667",
    stroke: "#D9754F",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCamOff;